
import { testOpenAIConnection } from './testConnection';
import { logger } from '@/utils/logger';

/**
 * Run a test of the OpenAI API connection and log the results
 * @param apiKey The OpenAI API key to test
 */
export async function runOpenAITest(apiKey: string): Promise<void> {
  console.log('Starting OpenAI API test...');
  
  if (!apiKey) {
    console.error('No API key provided. Please provide a valid OpenAI API key.');
    return;
  }
  
  try {
    const testResult = await testOpenAIConnection(apiKey);
    
    if (testResult.success) {
      console.log('✅ OpenAI API test successful!');
      console.log('Response:', testResult.response);
    } else {
      console.error('❌ OpenAI API test failed!');
      console.error('Error:', testResult.error);
    }
  } catch (error) {
    console.error('❌ Unexpected error during OpenAI test:', error);
  }
}

// Export the test function so it can be easily called from other files
export { testOpenAIConnection } from './testConnection';
